import { track } from "../track";

export const trackLogInView = () => track({ event: "log_in_view" });
